export default __webpack_public_path__ + "static/4-bf3c68bd1c269e1d060ea38715be67c5.jpeg";